import { render, staticRenderFns } from "./ProdWorkorderview.vue?vue&type=template&id=a713e86e&"
import script from "./ProdWorkorderview.vue?vue&type=script&lang=js&"
export * from "./ProdWorkorderview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports